module.exports = __webpack_public_path__ + "09_mole.94de6b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer2/09_mole.png
// module id = fl8d
// module chunks = 0